<template>
  <div class="pl-5 ml-4 h-100 pt-3">
    <div class="accordion">
      <div class="card brown border-0" v-for="(obj, order) in AllTime" :key="order">
        <div
          class="card-header bg-bright-red border"
          id="week"
          data-toggle="collapse"
          :data-target="'#week'+obj.BusinessOpenTimeId"
          aria-expanded="true"
          :aria-controls="'week'+obj.BusinessOpenTimeId"
        >
          <h2 class="mb-0 text-center titleTime">
            {{ obj.CheckIn }}
            <i class="las la-angle-double-right"></i>
            {{ obj.CheckOut }}
          </h2>
        </div>
        <div :id="'week'+obj.BusinessOpenTimeId" class="collapse show" aria-labelledby="week">
          <div class="container-fluid p-0">
            <ul class="row p-0 m-0 bg-bright-red">
              <li
                class="card col-6 col-sm-4 col-lg-3 col-xl bg-bright-red"
                v-for="(item, index) in obj.Week"
                :key="index"
              >
                <div class="card-body p-1 p-sm-4">
                  <small>{{ item.WeekDay }}</small>
                  <h2 class="card-title text-center" @click="updBtn(order,index)">
                    <i class="las la-calendar-check" v-show="item.Enable"></i>
                    <i class="lar la-calendar-times navy" v-show="!item.Enable"></i>
                  </h2>
                  <div class="row" v-show="item.Enable">
                    <div class="col-12 col-sm-5 col-xl-6 d-flex align-items-center">
                      <p class="m-0">限制人數</p>
                    </div>
                    <div class="col-12 col-sm-7 col-xl-6 pl-sm-0">
                      <select
                        class="custom-select brown bg-transparent"

                        :value="item.People"
                        @input="updPeopleNumber"
                        @change="updPeople(order, index)"
                      >
                        <option v-for="index in 100" :key="index-1" :value="index-1">{{ index-1 }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-bottom">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-outline-secondary mb-4 mr-5"
          @click="EditAndCreateRoleOpenTime"
        >儲存</button>
        <button type="button" class="btn btn-outline-secondary mb-4 mr-5">返回</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RolePeriod',
  data () {
    return {
      number: 0
    }
  },
  computed: {
    AllTime () {
      return this.$store.state.roleOpenTime
    }
  },
  methods: {
    updBtn (order, index) {
      const str = 'btn'
      this.$store.commit('roleTime', { order, index, str })
    },
    updPeopleNumber (e) {
      this.number = parseInt(e.path[0].value)
    },
    updPeople (order, index) {
      const str = 'people'
      const int = this.number
      this.$store.commit('roleTime', { order, index, str, int })
    },
    EditAndCreateRoleOpenTime () {
      var [...arr] = this.AllTime
      arr.forEach(item => {
        item.Monday = item.Week[1].Enable
        item.MondayPeople = item.Week[1].People
        item.TuesDay = item.Week[2].Enable
        item.TuesdayPeople = item.Week[2].People
        item.Wednesday = item.Week[3].Enable
        item.WednesdayPeople = item.Week[3].People
        item.Thursday = item.Week[4].Enable
        item.ThursdayPeople = item.Week[4].People
        item.Friday = item.Week[5].Enable
        item.FridayPeople = item.Week[5].People
        item.Saturday = item.Week[6].Enable
        item.SaturdayPeople = item.Week[6].People
        item.Sunday = item.Week[0].Enable
        item.SundayPeople = item.Week[0].People
        delete item.Week
        delete item.CheckIn
        delete item.CheckOut
      })
      const vm = this
      const url =
        'http://imrebooksystem.rocket-coding.com/BusinessRoleOpenTimes/EditAndCreateRoleOpenTime'
      this.axios
        .post(url, arr)
        .then(function (res) {
          if (res.data === '儲存成功') {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'success',
              title: '儲存成功',
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
              }
            })
            vm.$router.push('/increase')
          } else {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'error',
              title: res.data,
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
              }
            })
          }
        })
        .catch(error => console.error(error))
    }
  },
  created () {
    const roleId = this.$route.params.roleId
    const vm = this
    const url =
      'http://imrebooksystem.rocket-coding.com/BusinessRoleOpenTimes/GetBusinessRoleOpenTime'
    this.axios
      .get(url, { params: { id: roleId } })
      .then(function (res) {
        if (res.data.length === 0) {
          vm.$store.dispatch('GetOpenTime', roleId)
        } else {
          vm.$store.commit('roleTime', res.data)
        }
      })
      .catch(error => console.error(error))
  }
}
</script>

<style lang="scss">
@media (max-width: 576px) {
  .titleTime {
    font-size: 1rem;
  }
}
</style>
